import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import styles from './search-trigger.module.css';

interface SearchTriggerProps {
  onClick: () => void;
}

export const SearchTrigger = ({ onClick }: SearchTriggerProps) => {
  const isMac =
    typeof navigator !== 'undefined' &&
    navigator.platform.toUpperCase().indexOf('MAC') >= 0;

  return (
    <button
      className={styles.trigger}
      onClick={onClick}
      type="button"
      aria-label="Search and commands"
    >
      <MagnifyingGlassIcon height={16} width={16} />
      <span className={styles.text}>Search...</span>
      <kbd className={styles.shortcut}>{isMac ? '\u2318' : 'Ctrl'}K</kbd>
    </button>
  );
};
